import { LOGIN, LOGOUT } from "./actionType";

export const loggedIn = (payload) => ({ type: LOGIN, payload });
export const loggedOut = () => ({ type: LOGOUT });
